module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-product",
    on: {
      "click": _vm.jump
    }
  }, [_c('div', {
    staticClass: "product-image"
  }, [_c('beast-image', {
    attrs: {
      "lazy": true,
      "src": _vm.productImage
    }
  }), _vm._v(" "), (_vm.data.foretell) ? _c('div', {
    staticClass: "foretell-box"
  }, [_c('div', {
    staticClass: "foretell"
  }, [_vm._v("即将开售")])]) : _vm._e(), _vm._v(" "), (_vm.data.activityDesc) ? _c('div', {
    staticClass: "activity-desc"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
    staticClass: "corner-box"
  }, [_c('div', {
    staticClass: "corner-label",
    style: (_vm.offShelfStyle)
  })]) : (_vm.data.soldOut) ? _c('div', {
    staticClass: "corner-box"
  }, [_c('div', {
    staticClass: "corner-label",
    style: (_vm.soldOutStyle)
  })]) : _vm._e(), _vm._v(" "), (_vm.addToCart) ? _c('div', {
    staticClass: "add-cart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCart.apply(null, arguments)
      }
    }
  }, [_c('beast-image', {
    attrs: {
      "src": "http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.summary))]), _vm._v(" "), _c('div', {
    staticClass: "brand-name"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tags-wrap"
  }, [(_vm.priceTags.vipLevelImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.vipLevelImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.priceTags.appOnlyImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.appOnlyImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.priceTags.birthdayImage) ? _c('div', {
    staticClass: "price-tag"
  }, [_c('beast-image', {
    attrs: {
      "src": _vm.priceTags.birthdayImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.rush) ? _c('div', {
    staticClass: "panic-tag"
  }, [_vm._v("抢购")]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f795aae"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/simple-product/index.vue
// module id = 171
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 15 16 17 19 23 24 27 28 30 36 39 40 44 45